import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Preloader.css';

const Preloader = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [progress, setProgress] = useState(0);
    const location = useLocation();

    useEffect(() => {
        // Show preloader on route change
        setIsLoading(true);
        setProgress(0);

        // Simulate loading progress
        const progressInterval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(progressInterval);
                    return 100;
                }
                // Faster progress for route changes
                return prev + Math.random() * 25;
            });
        }, 150);

        // Minimum display time for smooth UX
        const minDisplayTime = setTimeout(() => {
            setProgress(100);
            setTimeout(() => setIsLoading(false), 400);
        }, 800);

        return () => {
            clearInterval(progressInterval);
            clearTimeout(minDisplayTime);
        };
    }, [location.pathname]); // Re-run on route change

    if (!isLoading) return null;

    return (
        <div className={`preloader ${!isLoading ? 'preloader-hidden' : ''}`}>
            <div className="preloader-content">
                {/* Logo Animation */}
                <div className="preloader-logo">
                    <div className="logo-container">
                        <img
                            src="/atam-logo.svg"
                            alt="ATAM Connect"
                            className="atam-logo"
                            style={{ width: '200px', height: 'auto' }}
                        />
                    </div>
                </div>

                {/* Loading Text */}
                <div className="preloader-text">
                    <div className="loading-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                {/* Progress Bar */}
                <div className="progress-container">
                    <div className="progress-bar">
                        <div
                            className="progress-fill"
                            style={{ width: `${Math.min(progress, 100)}%` }}
                        ></div>
                    </div>
                    <div className="progress-text">{Math.round(Math.min(progress, 100))}%</div>
                </div>
            </div>

            {/* Animated Background */}
            <div className="preloader-bg">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
                <div className="gradient-orb orb-3"></div>
            </div>
        </div>
    );
};

export default Preloader;
